import { render, staticRenderFns } from "./RegisterHeader.vue?vue&type=template&id=00d7f251&scoped=true&"
import script from "./RegisterHeader.vue?vue&type=script&lang=js&"
export * from "./RegisterHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d7f251",
  null
  
)

export default component.exports